import { dispatchHydrateState, dispatchImportState, dispatchResetState, dispatchSaveState } from "..";
import { questionsUtils } from "../../..";
import { store } from "../../../store";
import { logger } from "@services/workers/helpers";
import ObjectsOperations from "@utils/objects/operations";
import StorageUtils from "@services/storage";
import { TemplateSTATEObject } from "@services/storage/storeTemplate";
import { stateSelector, storeName, initialState } from "../slice";
import { serviceManager } from "@services/workers";

const namespace = "State Reducer";

export const hydrateStateReducer = () => {
  const newState = ObjectsOperations.typeSafeStructuredClone<TemplateSTATEObject>(initialState);

  for (const key in newState) {
    const value = StorageUtils.getFromStorage({ type: "local", store: storeName, key });
    if (value) newState[key as keyof typeof newState] = value as never;
  }

  logger.debug(namespace + "->" + hydrateStateReducer.name, "Data loaded", newState);

  Object.entries(questionsUtils.getQuestions()).forEach(([key, value]) => {
    if (newState[`RequiredOption${value.getId() + 1}Valid` as keyof typeof newState] === undefined) {
      questionsUtils.setAnswer(value.getId(), newState[`RequiredOption${value.getId() + 1}Answer` as keyof typeof newState]);
    }
  });

  questionsUtils.checkValidity();

  dispatchHydrateState(newState);
  dispatchSaveState();
};

// resetState to initial state
export const resetStateReducer = (exceptions?: Array<string>) => {
  const exceptionsObj: any = {};
  const state = store.getState().state;

  if (exceptions && exceptions.length > 0) {
    exceptions.forEach((key) => {
      exceptionsObj[key] = ObjectsOperations.typeSafeStructuredClone(state[key as keyof typeof state]);
    });
  }

  dispatchResetState(exceptionsObj);
  dispatchSaveState();
};

// importState to state
export const importStateReducer = (state: TemplateSTATEObject) => {
  const stateOrg = stateSelector(store.getState());

  // remove BookingsSync from state
  state.BOOKING_DATA_SYNC = stateOrg.BOOKING_DATA_SYNC;

  // remove UsersStatistics from state
  state.UsersStatistics = stateOrg.UsersStatistics;
  // hydrating reducer
  dispatchImportState(state);
  // saving reducer to local storage (including job,call,globals,sa Objects)
  dispatchSaveState();

  serviceManager.sendMessageToWorker({
    serviceName: "LOG_SYNC",
    serviceData:
    {
      origin: "MAIN_THREAD",
      command: "SET_JOB_ID",
      payload: state.JobId,
    }
  });
};

export const resetSquareState = () => {
  dispatchResetState();
};
